@if (isVerified) {
<p-tabs class="secondary-tabs" value="0">
  <p-tablist>
    <p-tab value="0">PRN</p-tab>
    <p-tab value="1" (click)="loadMedicationsSchedule()">Scheduled</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      <app-prn-schedule></app-prn-schedule>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-scheduler-wrapper #scheduleWrapper />
      <!-- <app-medication-schedule #medicationSchedule></app-medication-schedule> -->
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
} @else {
<div class="verification-container">
  <h3>Please verify the patient's MRN by scanning the wristband.</h3>
  <emr-input type="text" label="Patient MRN" [control]="wristbandIdFormControl"></emr-input>
  <button pButton pRipple (click)="verify()">Verify Patient</button>
</div>
}